import React from 'react'
import BaseIcon from 'react-icon-base'
import { EColors } from 'app/constants/colors'

const Linkedin = props => (
  <BaseIcon width="14" height="14" viewBox="0 0 14 14" {...props}>
    <g fill={EColors.GREY} fillRule="evenodd">
      <path d="M2.168.582a1.608 1.608 0 1 1-.003 3.216A1.608 1.608 0 0 1 2.168.582zM.78 13.937h2.772v-8.92H.781v8.92zM5.293 5.016h2.659v1.219h.037c.37-.701 1.274-1.44 2.623-1.44 2.808 0 3.326 1.847 3.326 4.249v4.893h-2.77V9.599c0-1.035-.02-2.366-1.441-2.366-1.443 0-1.664 1.127-1.664 2.29v4.414h-2.77v-8.92z" />
    </g>
  </BaseIcon>
)

export default Linkedin
